<template>
  <div style="overflow: hidden; position: relative">
    <vs-row style="align-items: flex-end">
      <vs-col vs-w="6" vs-sm="12">
        عنوان میز:
        <vs-input v-model="title" class="w-100 mt-1" />
      </vs-col>
      <vs-col vs-w="6" vs-sm="12">
        ظرفیت میز:
        <vs-input v-model="capacity" class="w-100 mt-1" type="number" />
      </vs-col>
      <vs-col vs-w="12" vs-sm="12">
        <vs-button class="w-100" color="secondary" @click="handleOnSubmit">
          {{ selectedTable ? "ویرایش" : "ثبت" }}
        </vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import providerApiService from "../../../services/api/ProviderApiService";

export default {
  name: "Form.vue",
  data() {
    return {
      title: this.selectedTable?.title,
      capacity: this.selectedTable?.capacity,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  props: {
    selectedTable: {
      type: [Object, null],
      required: true,
    },
  },
  methods: {
    handleOnSubmit() {
      this.$vs.loading();
      providerApiService
        .createTable({
          title: this.title,
          capacity: this.capacity,
          providerId: this.currentProvider.id,
          tableId: this.selectedTable?.id,
        })
        .then(() => this.$emit("onTableChanged"))
        .catch((e) => console.log(e))
        .finally(() => this.$vs.loading.close());
    },
  },
};
</script>
